import { render } from "./ProviderDetails.vue?vue&type=template&id=59c05bde&ts=true"
import script from "./ProviderDetails.vue?vue&type=script&lang=ts"
export * from "./ProviderDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__